import { render, staticRenderFns } from "./ServiceAreas.vue?vue&type=template&id=67888f35"
import script from "./ServiceAreas.vue?vue&type=script&lang=js"
export * from "./ServiceAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports